import { useGetCreativesQuery } from '../../../api/ua-insights'
import type { ShowcasePatternArgs } from './useShowcasePatternDetail'
import { useUAInsightsScope } from './useUAInsightsNavigation'

/**
 * Example creatives for a story pattern, best performing first. With a
 * motivation lens it first asks for the creatives that also carry the
 * motivation; when none do, it falls back to the unlensed list and reports
 * `lensApplied: false`, matching how `/showcase` treats the lens.
 */
export const useShowcasePatternCreatives = ({ patternId, lensMotivationId, gameId }: ShowcasePatternArgs) => {
  const { networkId, month, genreFilter } = useUAInsightsScope()
  const base = {
    patternId,
    sort: 'installShare' as const,
    gameId: gameId ?? undefined,
    genreId: gameId ? undefined : genreFilter ?? undefined,
    networkId: networkId ?? undefined,
    month: month ?? undefined,
  }
  const lensed = useGetCreativesQuery({ ...base, carriesMotivationId: lensMotivationId ?? undefined }, { skip: !lensMotivationId })
  const lensEmpty = !!lensed.data && lensed.data.creatives.length === 0
  const unlensed = useGetCreativesQuery(base, { skip: !!lensMotivationId && !lensEmpty })

  const active = lensMotivationId && !lensEmpty ? lensed : unlensed
  const data = active.data ? { rows: active.data.creatives, total: active.data.page.total, lensApplied: active === lensed } : undefined
  return { data, isLoading: lensed.isFetching || unlensed.isFetching, isError: active.isError, refetch: active.refetch }
}
